import React from 'react'
import Layout from '../../Layout'
import IntelegentVoiceOrderContainer from '../../../../Components/OrdersPart/IntelegentVoiceOrderContainer/IntelegentVoiceOrderContainer'

const IntelegentVoiceOrder = () => {
  return (
    <Layout><IntelegentVoiceOrderContainer/></Layout>
  )
}

export default IntelegentVoiceOrder